import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { AskRequest } from '@hone-automation/common';
import { makeRemoteQueueRequestById } from 'main/factories/usecases/queue';
import { FIVE_MINUTES } from 'lib/utils';

/**
 * Returns a function that fetches a single queue request by ID
 * using the shared React Query cache (staleTime: 5min).
 */
export const useFetchQueueRequestById = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (requestId: string): Promise<AskRequest> =>
      queryClient.fetchQuery({
        queryKey: ['queueRequestById', requestId],
        queryFn: async () => {
          const service = makeRemoteQueueRequestById(requestId);
          return service.get() as Promise<AskRequest>;
        },
        staleTime: FIVE_MINUTES,
      }),
    [queryClient]
  );
};
